import { render } from "./QAQC.vue?vue&type=template&id=7f2ca1be"
import script from "./QAQC.vue?vue&type=script&lang=js"
export * from "./QAQC.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__